function e(n, a) {
  return n != null && a in Object(n);
}
export {
  e as default
};
